import { generateUUID } from '@qodly/shared';
import { ServerModel } from './types';

const addUUIDToModel = (content: ServerModel) => {
  const { dataClasses, ...rest } = content;

  return {
    ...rest,
    dataClasses: dataClasses?.map((dataclass) => {
      let _ds = { ...dataclass };

      if (!_ds.uuid) {
        _ds = {
          ..._ds,
          uuid: generateUUID(),
        };
      }

      if (_ds.attributes) {
        const kindToKeep = ['storage', 'relatedEntity'];

        const _attrs = _ds.attributes.map((attribute) => {
          if (kindToKeep.includes(attribute.kind) && !attribute.uuid) {
            return {
              ...attribute,
              uuid: generateUUID(),
            };
          }

          return attribute;
        });

        _ds = {
          ..._ds,
          attributes: [..._attrs],
        };
      }

      return _ds;
    }),
  };
};

export { addUUIDToModel };
